import { PropsWithChildren } from 'react'
import styles from '../styles.module.scss'
import { Gallery } from '../types'
import GalleryCard from './GalleryCard'

const GalleryList: React.FC<PropsWithChildren<Gallery.NewsListProps>> = ({ articles }) => {
  const articlesList = articles as Gallery.NewsListProps['articles']

  return (
    <div className={styles['th-mapslist-container']}>
      <div className={styles['th-mapslist']}>
        {articlesList.map((
          {
            node: {
              slug,
              featuredImage,
              date,
              excerpt,
              title,
              content,
              author,
              maps
            }
          }
        ) => (
          <GalleryCard
            key={slug}
            author={author}
            categories={maps}
            content={content}
            coverImage={featuredImage?.node}
            date={date}
            excerpt={excerpt}
            height='h-48'
            slug={slug}
            title={title}
          />
        ))}
      </div>
    </div>
  )
}

export default GalleryList
